import React from "react";
import { FaFileInvoiceDollar, FaUser, FaCalendarAlt, FaFileAlt } from "react-icons/fa";
import './InvoiceOverviewCardStyle.css';
import { ReportDescription } from "../../ScheduleDetails/Components/ReportDescription/ReportDescription";

const InvoiceOverviewCard = ({ invoices = [] }) => {
    // Small reusable detail row
    const DetailItem = ({ icon, label, value }) => (
        <div className="detail-item">
            <span className="schedule-detail-icon">{icon}</span>
            <div className="detail-content">
                {label && <label>{label}:</label>}
                <span>{value}</span>
            </div>
        </div>
    );

    return (
        <div className="invoice-overview-list">
            {invoices?.length > 0 ? (
                invoices.map((invoice, index) => (
                    <div key={index} className="invoice-overview-card">
                        {/* Card Header */}
                        <div className="invoice-overview-card-header">
                            <h3 className="invoice-overview-title">
                                {invoice?.InvoiceNo || "—"}{" "}
                                {/* <span className="invoice-client">
                                    {invoice?.Client ? `(${invoice.Client})` : ""}
                                </span> */}
                            </h3>

                            <span
                                className={`invoice-overview-status ${(invoice?.Status || "")
                                    .toLowerCase()
                                    .replace(" ", "-")
                                    }`}
                            >
                                {invoice?.Status}
                            </span>

                        </div>

                        {/* Invoice details */}
                        <div className="invoice-overview-details">
                            <DetailItem
                                icon={`O`}
                                label="Amount (AED)"
                                value={invoice?.Amount ? `${invoice.Amount} ` : "—"}
                            />
                            <DetailItem
                                icon={<FaCalendarAlt />}
                                label="Client"
                                value={invoice?.Client || "—"}
                            />

                            <ReportDescription description={invoice?.Description || `N/A`} />

                            {/* <DetailItem
                                icon={<FaFileAlt />}
                                label="Description"
                                value={invoice?.Description || "—"}
                            /> */}
                        </div>
                    </div>
                ))
            ) : (
                <p className="no-invoice-overview">No invoices available</p>
            )}
        </div>
    );
};

export default InvoiceOverviewCard;